/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody,
} from 'reactstrap';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import TesterModal from '../../components/Tester/modal';

import BaseGrid from '../../components/Common/BaseGrid';
import { Can } from '../../utilities/Can';
import { post } from '../../helpers/api_helper';

function Testers(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [signal, setSignal] = useState(0);
  const [shownCreate, setShownCreate] = useState(false);
  const [activeTester, setActiveTester] = useState(null);

  const deleteTester = async (tester) => {
    try {
      await post(`/api/testers/tester/${tester.id}/delete`, {});

      setSignal(signal + 1);
      toastr.success(`Deleted tester ID: ${tester.id}`, 'Success');
    } catch (error) {
      toastr.error(error.message, 'Error');
    }
  };

  const editTester = (tester) => {
    setActiveTester(tester);
    setShownCreate(true);
  };

  const showCreate = () => {
    setActiveTester({});
    setShownCreate(true);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col md="10">
            <Card>
              <CardBody>
                <Can i="see" this="tester">
                  <BaseGrid
                    url="/api/testers"
                    shouldPaginate={false}
                    shouldUpdate={signal}
                    hasSearch
                    create={showCreate}
                    config={
                    {
                      columns: {
                        id: { label: 'Tester ID', sort: true },
                        type: {
                          label: 'Type',
                          sort: false,
                          format: (x, o) => (o.device ? o.device.type : ''),
                        },
                        brand: {
                          label: 'Brand',
                          sort: false,
                          format: (x, o) => (o.device ? o.device.source : ''),
                        },
                        device: {
                          label: 'Model',
                          sort: false,
                          format: (x) => (x ? x.identifier : ''),
                        },
                        version: { label: 'Version', sort: false },
                        serial_number: { label: 'Serial', sort: false },
                        location: { label: 'Location', sort: true },
                        notes: { label: 'Notes', sort: false },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'edit',
                              icon: 'mdi mdi-pencil',
                              class: 'btn btn-sm btn-soft-info',
                              alt: props.t('Edit'),
                              click: editTester,
                            },
                            {
                              key: 'delete',
                              icon: 'mdi mdi-delete',
                              class: 'btn btn-sm btn-soft-danger',
                              alt: props.t('Delete'),
                              click: deleteTester,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 30,
                      },
                    }
                    }
                  />
                </Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <TesterModal
        shown={shownCreate}
        tester={activeTester}
        onSuccess={() => { setShownCreate(false); setSignal(signal + 1); }}
        onClose={() => setShownCreate(false)}
      />
    </div>
  );
}

Testers.defaultProps = {
  t: (x) => (x),
};

Testers.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Testers));
